/**
 * Enumeration of all game events
 */
export enum GameEvent {
    /** Represents the Switch Page event */
    SwitchPage = "switch-page",
    /** Represents the Update Game State event */
    UpdateGameState = "update-game-state",
};
